import React from 'react';
import { useMarket } from '../context/MarketContext';
import { toEAT } from '../utils/time';

export default function OrderBookPanel() {
  const { orderBook, lastUpdateTime, labelForSecId, selectedSymbol } = useMarket();

  return (
    <div style={{ background:'#1e293b', padding:20, borderRadius:8, border:'1px solid #334155' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <h3 style={{ margin:0, fontSize:16, fontWeight:600 }}>
          Order Book - {labelForSecId(selectedSymbol)}
        </h3>
        {lastUpdateTime && <span style={{ fontSize:11, color:'#94a3b8' }}>Updated: {toEAT(lastUpdateTime)}</span>}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>      
        {/* Bids */}
        <div style={{ marginBottom:8, flex:1, marginRight:16 }}>
          <h4 style={{ color:'#10b981', margin:'0 0 8px 0', fontSize:14 }}>Bids</h4>
          <div style={{ maxHeight:'100%', overflowY:'auto' }}>
            {orderBook.bids.length > 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 'bold', color: '#94a3b8', padding: '0 8px', marginBottom: '4px' }}>
                      <span>Price</span>
                      <span>Size</span>
                    </div>
                  ) : null}

            {orderBook.bids.length ? orderBook.bids.slice(0,100).map((bid,i)=>(
              <Row key={i} color="#10b981" bg={i%2===0?'rgba(16,185,129,.05)':'transparent'} p={bid.price} s={bid.size}/>
            )) : <Empty text="No bid orders"/>}
          </div>
        </div>

        {/* Asks */}
        <div style={{ marginBottom:8, flex:1 }}>
          <h4 style={{ color:'#ef4444', margin:'0 0 8px 0', fontSize:14 }}>Asks</h4>
          <div style={{ maxHeight:'100%', overflowY:'auto' }}>
              {orderBook.asks.length > 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 'bold', color: '#94a3b8', padding: '0 8px', marginBottom: '4px' }}>
                      <span>Price</span>
                      <span>Size</span>
                    </div>
                  ) : null}
            {orderBook.asks.length ? orderBook.asks.slice(0,100).map((ask,i)=>(
              <Row key={i} color="#ef4444" bg={i%2===0?'rgba(239,68,68,.05)':'transparent'} p={ask.price} s={ask.size}/>
            )) : <Empty text="No ask orders"/>}
          </div>
        </div>
      </div>

      <div style={{ textAlign:'center', padding:8, background:'#334155', borderRadius:6, margin:'8px 0', fontSize:12, color:'#94a3b8' }}>
        Spread: <span style={{ fontWeight:600, color:'#f59e0b' }}>
          {orderBook.bids[0] && orderBook.asks[0] ? (orderBook.asks[0].price - orderBook.bids[0].price).toFixed(2) : 'N/A'}
        </span>
      </div>
    </div>
  );
}

function Row({ color, bg, p, s }:{ color:string; bg:string; p:number; s:number }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', padding:'4px 8px', background:bg, borderRadius:3 }}>
      <span style={{ color, fontWeight:600, fontSize:12 }}>{p.toFixed(2)}</span>
      <span style={{ color:'#94a3b8', fontSize:12 }}>{s.toLocaleString()}</span>
    </div>
  );
}
const Empty = ({ text }:{ text:string }) =>
  <div style={{ color:'#94a3b8', fontSize:12, textAlign:'center', padding:20 }}>{text}</div>;
